module.exports = __webpack_public_path__ + "static/media/02d.fa2b63ff.svg";